module.exports = __webpack_public_path__ + "static/img/partner11.5ba2e24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner11.png
// module id = Wvrg
// module chunks = 0